var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14C8.87317 14 9.17603 13.6955 9.17603 13.3204L9.17603 4.43732L11.7877 7.06294C12.052 7.32868 12.48 7.32868 12.7437 7.06294L12.8018 7.00454C13.0661 6.7388 13.0661 6.30855 12.8018 6.04349L8.97797 2.1993C8.71365 1.93357 8.28568 1.93357 8.02203 2.1993L4.19825 6.04349C3.93392 6.30923 3.93392 6.73948 4.19825 7.00454L4.25634 7.06294C4.52067 7.32868 4.94864 7.32868 5.21229 7.06294L7.82397 4.43732L7.82397 13.3204C7.82397 13.6955 8.12683 14 8.5 14Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpward);
export default __webpack_public_path__ + "static/media/Arrow Upward.5adde500eabc37b60206459afb3271f3.svg";
export { ForwardRef as ReactComponent };